import {
    Filter,
    ExactFilter,
    RangeFilter,
    isExactFilter,
    ExactSign,
    BoundarySign,
} from 'utils/filter/filter';
import DateTimeExpression from 'utils/filter/expressions/DateTimeExpression';

export default function buildTimeFilterFunction(filter: Filter<number>) {
    if (isExactFilter(filter)) {
        const exactFilter = filter as ExactFilter<number>;
        return buildExactTimeFunction(exactFilter);
    }

    const rangeFilter = filter as RangeFilter<number>;
    return buildTimeRangeFunction(rangeFilter);
}

function buildExactTimeFunction(exactFilter: ExactFilter<number>) {
    const expression = new DateTimeExpression(exactFilter.value);
    switch (exactFilter.exactSign) {
        case ExactSign.EQ:
            return expression.testSameTime.bind(expression);
        case ExactSign.NEQ:
            return expression.testNotSameTime.bind(expression);
        default:
            return () => true;
    }
}

function buildTimeRangeFunction(rangeFilter: RangeFilter<number>) {
    const lowerFunction = buildTimeBoundaryFilterFunction(rangeFilter, 'l');
    const upperFunction = buildTimeBoundaryFilterFunction(rangeFilter, 'u');

    if (lowerFunction && upperFunction) {
        return (n: number) => lowerFunction(n) && upperFunction(n);
    } else if (lowerFunction && !upperFunction) {
        return (n: number) => lowerFunction(n);
    } else if (!lowerFunction && upperFunction) {
        return (n: number) => upperFunction(n);
    }
    return () => true;
}

function buildTimeBoundaryFilterFunction(
    rangeFilter: RangeFilter<number>,
    boundary: 'l' | 'u'
) {
    const targetValue =
        rangeFilter[boundary === 'l' ? 'lowerValue' : 'upperValue'];
    if (!targetValue) {
        return;
    }

    const expression = new DateTimeExpression(targetValue);
    switch (rangeFilter[boundary === 'l' ? 'lowerSign' : 'upperSign']) {
        case BoundarySign.GT:
            return expression.testTimeGreaterThan.bind(expression);
        case BoundarySign.GTE:
            return expression.testTimeGreaterThanOrEqual.bind(expression);
        case BoundarySign.LT:
            return expression.testTimeLessThan.bind(expression);
        case BoundarySign.LTE:
            return expression.testTimeLessThanOrEqual.bind(expression);
        default:
            return () => true;
    }
}
